import type { IconProps } from '../types/IconProps.ts';
export const MousePointer: IconProps = {
    name: 'MousePointer',
    children: [
        `<path d="M9.95 19.88 3.05 3.1a.05.05 0 0 1 .06-.06l16.77 6.9c.04.02.04.08 0 .1l-6.43 2.13a2 2 0 0 0-1.27 1.27l-2.14 6.42a.05.05 0 0 1-.1 0ZM13 13l6 6" />`,
    ]
};